import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Typography,Space, Image, theme, Skeleton, Tooltip, Flex } from 'antd'
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi } from '../../../shared';

const { useToken } = theme;
const { Title, Text } = Typography
const CardComponent = () => {
    const { token } = useToken();
    const dispatch = useDispatch()
    const { data, loading } = useSelector(state=>state?.cardapi)
    const [state, setState]= useState(null)

    useEffect(()=>{
        dispatch(actionsApi?.getAddCardDetail())
    },[])


    useEffect(()=>{
        if(data)
        {
            setState([
                {
                    title:data?.totalAppointments,
                    subtitle:'Total Appointment',
                    img:'appointment.png',
                    id:1
                },
                {
                    title:data?.totalJobs,
                    subtitle:'Total Projects',
                    img:'projects.png',
                    id:2
                },
                {
                    title:data?.totalTrans,
                    subtitle:'Total Transactions',
                    img:'transaction.png',
                    id:3
                },
            ])
        }
        else 
        setState(null)
    }, [data])
  return (
    <div>
        <Row gutter={[16,16]}>
            {
                loading ?
                new Array(3)?.fill(null)?.map((_, index)=>
                    <Col 
                        xs={24} sm={24} md={12} lg={12} xl={8} 
                        key={'skelton-card-' + index}
                    >
                        <Skeleton.Button 
                            active 
                            size='large' 
                            shape='square'
                            block
                            style={{width:'100%', height:'114px',borderRadius:20}}
                        />
                    </Col>
                )
                :
                state?.map((cdata,c)=>
                    <Col xs={24} sm={24} md={12} lg={8} xl={8} key={c}>
                        <Card style={{
                            borderColor: token.borderCardcolor,
                            width:"100%"}}
                            className={
                                cdata?.id === 1 ? 'card-cs card-rad border-btm-green shadow-d height-100':
                                cdata?.id === 2 ? 'card-cs card-rad border-btm-blue shadow-d height-100' :
                                cdata?.id === 3 ? 'card-cs card-rad border-btm-orange shadow-d height-100' :
                                ''
                            }
                        >
                            <Row justify='space-between' align='middle'>
                                <Col lg={18} md={16} xs={18} sm={18}>
                                    <div className='my-2'>
                                        <Space size={3} align='center'>
                                            <Title level={3} className='my-0'>
                                                {cdata?.title}
                                            </Title>  
                                            {
                                                cdata.key==='info' ?
                                                <Tooltip title={cdata?.info}>
                                                    <img src="/assets/icons/info.png" width={22} alt="" />    
                                                </Tooltip>
                                                :
                                                ''
                                            }    
                                        </Space>                                          
                                        <Title className='my-0 fs-14 fw-500' level={5}>{cdata?.subtitle}</Title>
                                    </div>
                                </Col>
                                <Col lg={6} md={8} xs={6} sm={6}>
                                    <Flex justify='end'>
                                        <Image src={'/assets/icons/'+cdata?.img} width={'45px'} preview={false} /> 
                                    </Flex>  
                                </Col>
                            </Row>
                        </Card> 
                    </Col>
                )
            }
        </Row>
    </div>
  )
}

export {CardComponent}